import { render, staticRenderFns } from "./clientsside.vue?vue&type=template&id=616855f5&scoped=true&"
import script from "./clientsside.vue?vue&type=script&lang=js&"
export * from "./clientsside.vue?vue&type=script&lang=js&"
import style0 from "./clientsside.vue?vue&type=style&index=0&id=616855f5&prod&scoped=true&lang=scss&"
import style1 from "./clientsside.vue?vue&type=style&index=1&id=616855f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616855f5",
  null
  
)

export default component.exports